import { render, staticRenderFns } from "./AddPosts.vue?vue&type=template&id=ec05fa4a&scoped=true"
import script from "./AddPosts.vue?vue&type=script&lang=js"
export * from "./AddPosts.vue?vue&type=script&lang=js"
import style0 from "./AddPosts.vue?vue&type=style&index=0&id=ec05fa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec05fa4a",
  null
  
)

export default component.exports